const state = {}

const getters = {
    getOrderStorage: () => (orderId) => {
        return JSON.parse(localStorage.getItem(`${checkOrderId(orderId)}`))
    },

    getFastTypingOrderStorage: () => () => {
        return JSON.parse(localStorage.getItem('fast-typing-order'))
    },
}

const actions = {
    setFastTypingOrderStorage({ commit, state }, order) {
        localStorage.setItem('fast-typing-order', JSON.stringify(order));
    },

    removeFastTypingOrderStorage({ commit, state }) {
        localStorage.removeItem('fast-typing-order')
    },

    setOrderStorage({ commit, state }, order) {
        localStorage.setItem(`${checkOrderId(order.id)}`, JSON.stringify(order));
    },

    removeOrderStorage({ commit, state }, orderId) {
        localStorage.removeItem(checkOrderId(orderId))
    },    
}

const mutations = {}

function checkOrderId(orderId) {
    let id = 'order'

    if (orderId) {
        id += `-${orderId}`
    }

    return id
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}